import type { SeriesFrame } from './seriesCatalog'

/**
 * Состав серии, разрешённый ЭТОМУ кабинету.
 *
 * Каталог слоёв — единственный источник прав (см. `hydrology.ts`): разрешено
 * ровно то, что в нём приехало. Кадр слоя, которого кабинету не выдали, в архив
 * не попадает — иначе кнопка «Серия» стала бы обходом гейта: растровые тайлы
 * среды сегодня отдаются без авторизации, и карта зоопланктона нарисовалась бы
 * в кабинете, купившем оценку без измерений.
 *
 * Инструменты над полем температуры (изотерма, термофронт, изолинии волнения)
 * уходят с кадра по тому же признаку, по которому их прячет сайдбар: сетку SST
 * закрытому кабинету не отдадут, и включённый тумблер над пустым полем врал бы
 * дважды — на картинке и в файле параметров.
 *
 * Изобаты и трек HSI остаются: дно — навигационная величина, а траектории —
 * оценка, ради которой кабинет и куплен.
 */
export function framesForCabinet(
  frames: SeriesFrame[],
  cabinet: { layerIds: string[]; hydrology: boolean },
): SeriesFrame[] {
  // Пустой каталог — «ещё не знаем», а не «ничего нельзя»: обрезав состав
  // здесь, мы отдали бы неполную серию тому, кому положена полная.
  if (cabinet.layerIds.length === 0) return frames
  const allowed = new Set(cabinet.layerIds)
  return frames
    // Права спрашиваются и у ПОДЛОЖКИ, и у самих оверлеев кадра. Проверив
    // только подложку, мы отдали бы кадр «Лёд» кабинету, которому лёд не
    // выдан: кадр оверлея лежит поверх общей батиметрии, и она разрешена
    // всем. Растровые тайлы среды отдаются без авторизации, так что картинка
    // нарисовалась бы честно — то есть кнопка стала бы обходом гейта.
    .filter(f => allowed.has(f.layer) && f.overlays.every(o => allowed.has(o)))
    .map(f =>
      cabinet.hydrology
        ? f
        : {
            ...f,
            isotherm: null,
            // Дочерние линии изотермы — та же среда: оставшись, они просили бы
            // сетку SST, которой закрытому кабинету не дадут.
            isothermSurface: null,
            isothermSpread: null,
            fronts: null,
            waveStep: null,
          },
    )
}
